import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Input, InputNumber, Space, Typography } from 'antd'
import { errorNotification, postRequest, successNotification, trackingAccountCreditsUrl } from '../../config'
import { errorSentence } from './utils'

// Recording what the ShipsGo dashboard says, by hand.
//
// It exists because the balance on this page is not read live: ShipsGo has no balance endpoint, so
// the number arrives on a response header and the only call that reads one is a shipment create.
// Between creates the figure goes stale — and it goes stale in the one direction that hurts,
// because the moment somebody tops up is the moment nothing is being tracked. Production showed 2
// credits for three weeks and sent the same low-credit alert 93 times against a real balance of
// about 12.
//
// Deliberately not a "clear the alert" button. The number goes through the same server code a
// shipment create goes through, so entering 0 RAISES the alert. Being able to quieten an alert
// without changing what we believe is how a dashboard starts lying.
const CreditsEditor = ({ onSaved }) => {
  const [credits, setCredits] = useState(null)
  const [note, setNote] = useState('')
  const [saving, setSaving] = useState(false)

  const save = async () => {
    const response = await postRequest(
      trackingAccountCreditsUrl,
      { credits, note: note.trim() },
      'credits',
      setSaving
    )
    if (!response.success) {
      errorNotification(errorSentence(response, 'That balance could not be recorded.'))
      return
    }
    successNotification('Balance recorded.')
    setCredits(null)
    setNote('')
    onSaved(response.data)
  }

  return (
    <div style={{ marginTop: 16 }}>
      <Typography.Text type="secondary">
        Read the balance off the ShipsGo dashboard and record it here. Entering 0 will raise the
        low-credit alert, not silence it.
      </Typography.Text>
      <Space style={{ marginTop: 8 }} wrap>
        <InputNumber
          min={0}
          max={100000}
          precision={0}
          value={credits}
          onChange={setCredits}
          placeholder="Credits"
          style={{ width: 120 }}
        />
        <Input
          value={note}
          onChange={event => setNote(event.target.value)}
          placeholder="Note (optional)"
          maxLength={200}
          style={{ width: 220 }}
        />
        <Button
          type="primary"
          loading={saving}
          disabled={credits === null || credits === undefined}
          onClick={save}
        >
          Record
        </Button>
      </Space>
    </div>
  )
}

CreditsEditor.propTypes = { onSaved: PropTypes.func.isRequired }

export default CreditsEditor
